module.exports = __webpack_public_path__ + "static/media/pornographyActive.1621a3c7.svg";